import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

import { COLORS } from "@/features/shared/constants";

export const ListContainer = styled("ul")`
  display: none;

  @media (min-width: 960px) {
    display: flex;
    flex-direction: row;
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export const Container = styled(Box)(
  ({ theme }) => `
  padding:  ${theme.spacing(1)} 0 0 20px;
  text-align: right;

  > svg {
    display: none;
  }

  @media (max-width: 960px) {
    padding:  0;
`,
);

export const MenuItem = styled(NavLink)(
  ({ theme }) => `
  align-items: center;
  background: rgba(21, 66, 115, 0.50);
  border-radius: 4px 4px 0px 0px;
  color: ${theme.palette.secondary.main};
  cursor: pointer;
  display: flex;
  margin-right: ${theme.spacing(0.5)};
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${theme.palette.primary.light};
    color: black;
  }

  &.active {
    background-color: ${theme.palette.primary.light};
    color: black;
  }
`,
);

export const MenuItemText = styled(Typography)(
  ({ theme }) => `
  font-weight: ${theme.typography.fontWeightBold};
  padding: ${theme.spacing(1)} ${theme.spacing(2)};
  @media (max-width: 960px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`,
);

export const SubMenu = styled(Box)(
  ({ theme }) => `

  background-color: ${theme.palette.primary.light};
  min-height: 0.9rem;

  `,
);

export const SubMenuItem = styled(MenuItem)(
  ({ theme }) => `
    color: black;
    font-weight: 'inherit';
    background-color: ${theme.palette.primary.light};
    border-radius: 4px 4px 0px 0px;

    &:hover {
        background-color: ${theme.palette.secondary.main};
        font-weight: ${theme.typography.fontWeightBold};
    }
    &.active {
      background-color: ${theme.palette.secondary.main};
      font-weight: ${theme.typography.fontWeightBold};
      border-top-color: 3px solid black;
    }
    `,
);

export const SubMenuItemText = styled(MenuItemText)`
  font-weight: inherit;
  color: ${COLORS.default.normal};
`;

export const HamburgerMenu = styled(Box)`
  display: none;

  @media (max-width: 960px) {
    display: block;

    ul {
      display: block;
      padding-left: 0;
    }
  }
`;

export const MobileContainer = styled(Box)(
  ({ theme }) => `
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: ${theme.palette.primary.dark};
  opacity: 0.95;
  color: black;
  text-align: right;
  overflow-y: scroll;

  > svg {
    color: white;
  }

  > div:first-of-type {
    display: flex;
    position: sticky;
    justify-content: flex-end;
    padding: ${theme.spacing(2)};
    top: 0;
    left: 0;
    background-color: ${theme.palette.primary.dark};
  }
  `,
);

export const IconBox = styled("div")(
  ({ theme }) => `
 display: flex;
 color: white;
 cursor: pointer;
 padding: ${theme.spacing(1)};

 svg {
  margin-right: ${theme.spacing(1)};
 }

 @media (min-width: 960px) {
  display: none;
 }
`,
);
